import { useNavigate } from "react-router-dom";
import { FIELDS } from "../utils/constants"
import { useState } from "react";
import RequestModal from "../../containers/shared/RequestModal";
import GetRequestStyle from "../helpers/GetRequestStyle";
import GetServiceByCode from "../helpers/GetServiceByCode";
import DownArrowIcon from "../icons/down-arrow";
import apiClient from "../utils/apiClient";

export default function RequestsTable({ requests, hidePropertyAndUnitNames=false, type="sub",currentPage=false,pageSize=0, user=false ,fields=false,handleRefreshRequests=null, setIsLoading=null }) {

    const navigate = useNavigate();

    const [selectedRequest, setSelectedRequest] = useState();
    const [showRequestDetails, setShowRequestDetails] = useState(false);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [prevService, setPrevService] = useState(false);
    const [mainFieldChanged, setMainFieldChanged] = useState(false);
    const [selectedRequestId, setSelectedRequestId] = useState(null);

    const sortBySoonest = (list) => {
        const currentDate = new Date()
        return list.sort(function (a, b) {
            let dateA = new Date(a.startWorkingDate)
            let dateB = new Date(b.startWorkingDate)
            if (dateA > currentDate || dateB > currentDate) {
                return -1;
            }
            return dateA - dateB;
        });
    }

    const getStartWorkingDate = (request) => {
        if(request?.startWorkingDate) {
            return new Date(request?.startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.units?.length > 1) {
                    sortedRequests = sortBySoonest(request?.units);
                } else {
                    sortedRequests = request?.units;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.startWorkingDate) {
                let sortedRequests;
                if(request?.subRequests?.length > 1) {
                    sortedRequests = sortBySoonest(request?.subRequests);
                } else {
                    sortedRequests = request?.subRequests;
                }
                return new Date(sortedRequests[0].startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'});
            } else {
                return 'غير محدد';
            }
        }
    }

    const getUnitsNames = (request) => {
        if(request?.unitName) {
            return request?.unitName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.unitName) {
                if(request?.units?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.units?.map((unit, index) => {
                        unitsNames = [...unitsNames, unit?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.units[0]?.unitName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.unitName) {
                if(request?.subRequests?.length > 1) {
                    let unitsNames = [];
                    let unitsText;
                    request.subRequests?.map((sub, index) => {
                        unitsNames = [...unitsNames, sub?.unitName];
                    });
                    [...new Set(unitsNames)].map((p,i)=> i===0 ? unitsText = ''+p : unitsText += ' + ' + p);
                    return unitsText;
                } else {
                    return request?.subRequests[0]?.unitName;
                }
            } else {
                return 'غير محدد';
            }
        }
    }

    const getPropertiesNames = (request) => {
        if(request?.propertyName) {
            return request?.propertyName;
        } else {
            if(request?.units && Array.isArray(request?.units) && request?.units?.length > 0 && request?.units[0]?.propertyName) {
                if(request?.units?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.units?.map((unit, index) => {
                        propertiesNames = [...propertiesNames, unit?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.units[0]?.propertyName;
                }
            } else if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0 && request?.subRequests[0]?.propertyName) {
                if(request?.subRequests?.length > 1) {
                    let propertiesNames = [];
                    let propertiesText;
                    request.subRequests?.map((sub, index) => {
                        propertiesNames = [...propertiesNames, sub?.propertyName];
                    });
                    [...new Set(propertiesNames)].map((p,i)=> i===0 ? propertiesText = ''+p : propertiesText += ' + ' + p);
                    return propertiesText;
                } else {
                    return request?.subRequests[0]?.propertyName;
                } 
            } else {
                return 'غير محدد';
            }
        }
    }

    const getFieldName = (request) => {
        if(request?.field?.name?.indexOf("'") > -1) {
            return request?.field?.name?.split("'")[1];
        } else {
            if(request?.field?.name) {
                return request?.field?.name;
            } else {
                return request?.field;
            }
        }
    }


    requests.sort((a, b) => {
        if (a.prettyId < b.prettyId) return 1;
        if (a.prettyId > b.prettyId) return -1;
        return 0;
      });
      

    const handleClickRequestRow = (request) => {
        if(type === 'sub') {
            navigate(`/ar/subRequest/${request?._id}`);
        } else {
        if(request?.subRequests && Array.isArray(request?.subRequests) && request?.subRequests?.length > 0) {
            if(request?.subRequests?.length > 1) {
                navigate(`/ar/requests/${request?._id}`);
            } else {
                const subrequest = request?.subRequests[0];
                subrequest.field = request?.field;
                subrequest.createdBy = request?.createdBy;
                setSelectedRequestId(request?._id);
                setSelectedRequest(subrequest);
                setShowRequestDetails(true);
            }
        }
    }
    }

    const handleClickShowPopup = (request) => {
        // setSelectedRequest(request);
        // setShowRequestDetails(true);
    }

    const handleCloseModal = () => {
        setShowRequestDetails(false);
    }

    const getFieldNameAr = (field) => {
        if(fields) {
            return fields?.find(f=>f?.field?.code === field)?.field?.name?.ar;
        } else {
            return FIELDS[field]?.ar;
        }
    }

    const getFieldIcon = (field) => {
        if(FIELDS[field]?.icon) {
            return "url('/assets/images/"+FIELDS[field]?.icon+"')";
        } else {
            return "url('"+fields?.find(f=>f?.field?.code === field)?.field?.url+"')";
        }
    }

    const getFieldCategoryAr = (field,subFieldCode) => {
        if(fields) {
            let fieldCategory;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        fieldCategory = d?.device?.name?.ar;
                    }
                })
            })
            return fieldCategory;
        } else {
            return GetServiceByCode(field, subFieldCode)[0];
        }
    }

    const getSubFieldAr = (field,subFieldCode) => {
        if(fields) {
            let subField;
            fields?.find(f=>f?.field?.code === field) && fields?.find(f=>f?.field?.code === field)?.maintenanceListPerDevice?.map((d) =>{
                d?.maintenanceList?.map(m=>{
                    if(m?.code === subFieldCode) {
                        subField = m?.name?.ar;
                    }
                })
            })
            return subField;
        } else {
            return GetServiceByCode(field, subFieldCode)[1];
        }
    }

    const handleClickCancelConfirmPriceChange = () => {
        if(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.needConfirmation) {
            AcceptSubRequestPriceEditing();
        } else {
            AcceptRequestPriceEditing();
        }
    }

    const AcceptRequestPriceEditing = async () => {
        setIsLoading(true)
        setShowRequestDetails(false);
        try {
            const response = await apiClient.patch(`/b-business-requests/${selectedRequestId}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                handleRefreshRequests();
            }
        } catch(err) {}
        

    }

    const AcceptSubRequestPriceEditing = async () => {
        setIsLoading(true)
        setShowRequestDetails(false);
        try {
            const response = await apiClient.patch(`/b-business-requests/sub-request/${selectedRequest?._id}/confirm-price-editing`);
            if(response?.status === 201 || response?.status === 204 || response?.status === 200) {
                handleRefreshRequests();
            }
        } catch(err) {}

    }

    return (
        <>
        <div className="pb-[30px]">
            <table className="w-full mt-[30px]" dir="rtl">
                <thead>
                <tr className="border-b-[2px] border-b-grey-50">
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tr-[8px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">#</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">رقم الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">تاريخ البدء</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">أنشئ بواسطة</th>
                    {/* {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">المنشأة</th> */}
                    {!hidePropertyAndUnitNames && <><th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الوحدة</th></>}
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">الخدمة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px] border-l-[1px] border-l-grey-100">التكلفة</th>
                    <th className="bg-darkBlue text-white leading-[56px] text-start px-[15px] text-[16px] font-[500px]">حالة الطلب</th>
                    <th className="bg-darkBlue text-white leading-[56px] rounded-tl-[8px] text-start px-[15px] text-[16px] font-[500px]"></th>
                </tr>
                </thead>
                <tbody>
                {requests.map((request, index) => {;
                    return (
                    <tr key={`requests-${index}`} className={`${index !== requests?.length-1 && 'border-b-[1px] border-b-grey-200'}`}>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap w-[52px] cursor-pointer ${index === requests?.length-1 && 'rounded-br-[8px]'}`} onClick={()=>handleClickRequestRow(request)}>{currentPage ? ((currentPage-1)*pageSize) + (index+1) : index+1}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.prettyId}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getStartWorkingDate(request)}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{request?.statuses[0]?.createdBy?.name}</td>
                        {/* {!hidePropertyAndUnitNames && <><td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getPropertiesNames(request)}</td> */}
                        {!hidePropertyAndUnitNames && <><td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getUnitsNames(request)}</td></>}
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}>{getFieldNameAr(request?.field) || 'غير معرف'}</td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}><span className="font-[600]">{request?.status === 'awaiting-price-confirmation' ? request?.requestActivityLogs[request?.requestActivityLogs?.length-1]?.updatedField?.invoiceDetails?.total?.toFixed(2) : request?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap cursor-pointer`} onClick={()=>handleClickRequestRow(request)}><span className={`font-[600] ${GetRequestStyle(request?.status,'color')}`}>{GetRequestStyle(request?.status)}</span></td>
                        <td className={`bg-white h-[64px] pt-[14px] px-[15px] text-grey-600 font-[500] text-[14px] !text-right whitespace-nowrap w-[48px] ${index === requests?.length-1 && 'rounded-bl-[8px]'}`}>
                            {request?.status === 'awaiting-price-confirmation' ? <div className="cursor-pointer select-none w-[16px] h-[16px] !bg-center !bg-contain" style={{background:"url('/assets/images/more.svg')"}} onClick={()=>setDropDownOpen(prev=> prev === index+1 ? false : index+1)}></div> : ''}
                            {dropDownOpen === index+1 ? <div className="bg-white py-[8px] px-[12px] w-[142px] absolute end-[20px] rounded-b-[8px] shadow-[0px_0px_5px_0px_rgba(0,0,0,0.05)]">
                                <div className="cursor-pointer py-[8px] px-[12px] font-[500] text-[16px] text-grey-600" onClick={()=>handleClickRequestRow(request)}>مراجعة التغييرات</div>
                            </div> : ''}
                        </td>
                    </tr>
                    )
                })}
                </tbody>
            </table> 
        </div>

          { showRequestDetails && <RequestModal bgColor={GetRequestStyle(selectedRequest?.status,'bg')} heading={GetRequestStyle(selectedRequest?.status,'heading')} handleCloseModal={handleCloseModal}>
            <div className={`${(selectedRequest?.status === 'awaiting-price-confirmation' && selectedRequest?.createdBy === user?._id) ? 'pb-[87px]' : ''}`}>
                <div className="">
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] px-[16px]">
                        <span className="text-[12px] text-grey-900 font-[600]">رقم الطلب:</span> {selectedRequest?.prettyId}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">تاريخ البدء:</span> {new Date(selectedRequest?.startWorkingDate).toLocaleDateString("ar-eg", {year: 'numeric', month: 'long', day: 'numeric'})}
                    </div>
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">أنشئ بواسطة:</span> {selectedRequest?.statuses[0]?.createdBy?.name}
                    </div>
                    {/* <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">المنشأة:</span> {selectedRequest?.propertyName}
                    </div> */}
                    <div className="text-[14px] text-grey-600 font-[500] h-[30px] leading-[30px] my-[10px] mx-[16px] border-t-[1px] border-t-grey-200">
                        <span className="text-[12px] text-grey-900 font-[600]">الوحدة:</span> {selectedRequest?.unitName}
                    </div>
                    {selectedRequest?.notes ? <div className="text-[14px] text-grey-600 font-[500] my-[10px] mx-[16px] border-t-[1px] min-h-[30px] border-t-grey-200 whitespace-nowrap">
                        <span className="text-[12px] text-grey-900 font-[600] inline-block align-top w-[85px] leading-[30px]">ملاحظات الخدمة:</span>
                        <p className="inline-block align-top ms-[8px] whitespace-normal w-[calc(100%-93px)] pt-[5px]"> {selectedRequest?.notes?.notes || 'غير معرف'}</p>
                    </div> : ''} 
                </div>
                <div  className="p-[16px] bg-grey-50 my-[10px] border-t-[1px] border-t-grey-200 border-b-[1px] border-b-grey-200">
                    <div className="flex flex-nowrap mb-[10px]">
                        <div className="w-[50%] text-[16px] text-grey-900 font-[600]">تفاصيل الخدمه</div>
                        <div className="w-[50%] text-end"></div>
                    </div>
                    {selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.subFields?.map((service,index)=>{
                            return (
                                <div key={`initialWorkList-${selectedRequest?._id}-${index}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field)}</p>
                                        </div>
                                    </div>
                                    <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                            )
                        }) 
                    : selectedRequest?.initialWorkList?.map((service,index)=>{
                            return (
                                <div key={`initialWorkList-${selectedRequest?._id}-${index}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.field)}</p>
                                        </div>
                                    </div>
                                    <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                            )
                        }) }
                    <div className="flex flex-nowrap mb-[10px]">
                        <div className="w-full text-[16px] text-grey-900 font-[600]">الوحدات</div>
                    </div>
                    <div>
                        <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                            {selectedRequest?.unitName}
                        </div>
                    </div>
                </div>
                {selectedRequest?.status === 'awaiting-price-confirmation' ? <div  className={`bg-grey-200 my-[10px] mt-[-10px] relative max-h-[42px] transition-all duration-300 overflow-hidden border-y border-[transparent] ${prevService ? '!max-h-[1000px] !bg-grey-100 !border-grey-600' : ''}`}>
                    <div className="cursor-pointer h-[42px] leading-[42px] flex flex-nowrap select-none px-[16px]" onClick={()=> setPrevService(prev=>!prev)}>
                        <div className="w-[75%] text-[17px] font-[600] text-grey-900">تفاصيل الخدمة المعدلة</div>
                        <div className="w-[25%] text-end"><DownArrowIcon revarse={prevService} /></div>
                    </div>
                    {selectedRequest?.subRequestActivityLogs && Array.isArray(selectedRequest?.subRequestActivityLogs) && selectedRequest?.subRequestActivityLogs?.length > 0 ? 
                    <div className="pt-[16px] px-[16px] opacity-50">
                        {selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields && selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.subFields?.map((service,i)=>{
                            return (
                                <div key={`sub-request-activity-log-${i}`} className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                    <div className="w-full max-w-[228px]">
                                        <div className="inline-block align-middle w-[32px] h-[32px] me-[10px] grayscale-[100]" style={{backgroundImage:getFieldIcon(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field),backgroundSize: "contain", backgroundRepeat: "no-repeat"}}></div>
                                        <div className="inline-block align-middle">
                                            <p className="text-[#616161]">الخدمة الأساسية</p>
                                            <p className="text-[#212121] text-[16px] font-[600]">{getFieldNameAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field)}</p>
                                        </div>
                                    </div>
                                    <div className="w-full max-w-[180px]">
                                        <p className="text-[#616161]">نوع الخدمة</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getFieldCategoryAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">أسم الخدمة الفرعية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{getSubFieldAr(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.field, service?.maintenanceCode)}</p>
                                    </div>
                                    <div className="w-full max-w-[280px]">
                                        <p className="text-[#616161]">الكمية</p>
                                        <p className="text-[#212121] text-[16px] font-[600]">{service?.amount}</p>
                                    </div>
                                </div>
                            )}
                        )}
                        <div className="flex flex-nowrap mb-[10px]">
                            <div className="w-full text-[16px] text-grey-900 font-[600]">الوحدات</div>
                        </div>
                        <div>
                            <div className="inline-block align-middle px-[8px] rounded-[8px] h-[32px] leading-[32px] text-grey-900 font-[500] text-[16px] bg-[rgba(30,41,59,0.1)] me-[10px]">
                                {selectedRequest?.unitName}
                            </div>
                        </div>
                        <div className="h-[24px] leading-[24px] my-[17px] flex flex-nowrap select-none">
                            <div className="w-[75%] text-[17px] font-[600] text-grey-900">اجمالي الفاتورة القديمة</div>
                            <div className="w-[25%] text-end font-bold ">{selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.previousWorkList?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>: ''}
                </div> : ''}
                <div className="p-[16px]">
                    <p className="mb-[16px] font-[600] text-[16px] text-grey-900">تفاصيل الفاتورة</p>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي قطع الغيار المطلوبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.partsCost.toFixed(2) : selectedRequest?.invoiceDetails?.partsCost?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي راتب العمالة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.workerWage.toFixed(2) :  selectedRequest?.invoiceDetails?.workerWage?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">المجموع</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? Number(selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.workerWage + selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.partsCost)?.toFixed(2) : Number(selectedRequest?.invoiceDetails?.workerWage + selectedRequest?.invoiceDetails?.partsCost)?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                        <div className="flex flex-nowrap my-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">الضريبة</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.vatValue?.toFixed(2) :selectedRequest?.invoiceDetails?.vatValue?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                    <div className="border-t-[1px] border-dotted border-grey-300">
                        <div className="flex flex-nowrap mt-[10px] leading-[30px] h-[30px]">
                            <div className="w-[50%] text-[16px] text-grey-600 font-[500]">إجمالي ما سيتم دفعه</div>
                            <div className="w-[50%] text-[16px] text-grey-900 font-[500] text-end">{selectedRequest?.status === 'awaiting-price-confirmation' ? selectedRequest?.subRequestActivityLogs[selectedRequest?.subRequestActivityLogs?.length-1]?.updatedWorkList?.invoiceDetails?.total?.toFixed(2) : selectedRequest?.invoiceDetails?.total?.toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-middle inline-block select-none" /></div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedRequest?.status === 'awaiting-price-confirmation' && user?._id === selectedRequest?.createdBy ? <>
                <div className="absolute bottom-0 left-0 w-full h-[87px] bg-white text-end shadow-[0_-4px_24px_0_rgba(0,0,0,0.08)] pt-[20px] px-[15px]">
                    {/* <div className="w-[201px] h-[48px] leading-[48px] bg-white text-danger border-[1px] border-danger rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600] me-[16px]" onClick={handleClickCancelRequest}>الغاء الطلب</div> */}
                    <div className="w-[166px] h-[48px] leading-[48px] bg-darkBlue text-white border-[1px] border-darkBlue rounded-[8px] cursor-pointer inline-block text-center select-none text-[18px] font-[600]" onClick={handleClickCancelConfirmPriceChange}>التأكيد و الدفع</div>
                </div>
            </> : ''}
        </RequestModal> }

        </>
    )
}

